import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-investoradduser',
  templateUrl: './investor-add-user.component.html',
  styleUrls: ['./investor-add-user.component.css']
})
export class InvestorAddUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/investor/adduser/investor-add-user.component.ts